/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateArtifactDtoContent } from './UpdateArtifactDtoContent';
import {
    UpdateArtifactDtoContentFromJSON,
    UpdateArtifactDtoContentFromJSONTyped,
    UpdateArtifactDtoContentToJSON,
    UpdateArtifactDtoContentToJSONTyped,
} from './UpdateArtifactDtoContent';

/**
 * 
 * @export
 * @interface UpdateArtifactDto
 */
export interface UpdateArtifactDto {
    /**
     * 
     * @type {UpdateArtifactDtoContent}
     * @memberof UpdateArtifactDto
     */
    content: UpdateArtifactDtoContent;
}

/**
 * Check if a given object implements the UpdateArtifactDto interface.
 */
export function instanceOfUpdateArtifactDto(value: object): value is UpdateArtifactDto {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function UpdateArtifactDtoFromJSON(json: any): UpdateArtifactDto {
    return UpdateArtifactDtoFromJSONTyped(json, false);
}

export function UpdateArtifactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateArtifactDto {
    if (json == null) {
        return json;
    }
    return {
        
        'content': UpdateArtifactDtoContentFromJSON(json['content']),
    };
}

export function UpdateArtifactDtoToJSON(json: any): UpdateArtifactDto {
    return UpdateArtifactDtoToJSONTyped(json, false);
}

export function UpdateArtifactDtoToJSONTyped(value?: UpdateArtifactDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': UpdateArtifactDtoContentToJSON(value['content']),
    };
}

